import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import Loading from '../../Components/Loading';
import { LoginState, useAuthentication } from '../../Contexts/AuthenticationProvider';
import { useConfig } from '../../Contexts/ConfigProvider';
import { MYBOOKS_BASE_PATH } from '../constant';

const SignIn = () => {
  const { loginState } = useAuthentication();
  const { userPortal } = useConfig();
  const navigate = useNavigate();

  const userPortalUrl = useMemo(() => {
    const clientId = userPortal.client.id;
    const responseType = userPortal.client.responseType;
    const redirectUrl = userPortal.redirectUrl.login;
    const loginUrl = userPortal.userPortalUrl.login;

    return loginUrl
      .replace('{client_id}', clientId)
      .replace('{redirect_uri}', redirectUrl)
      .replace('{response_type}', responseType);
  }, [userPortal]);

  useEffect(() => {
    if (loginState === LoginState.LOGGED_IN) {
      navigate(MYBOOKS_BASE_PATH, { replace: true });
      return;
    }

    if (loginState === LoginState.NOT_LOGGED_IN) {
      if (userPortalUrl && userPortalUrl.startsWith('/')) {
        navigate(userPortalUrl, { replace: true });
      } else {
        window.location.href = userPortalUrl ?? '/';
      }
      return;
    }
  }, [loginState, navigate, userPortalUrl]);

  return <Loading open />;
};

export default SignIn;
